export default "__VITE_ASSET__NKcVy5fK__"